import React from 'react';
import PropTypes from 'prop-types';
import './LinkPro.css';

import Button from '../../../common/Button';
import IconClose from '../../../svg/IconClose';
import LogoLink from '../svg/LogoLink';
const LMC = require(`../media/LMC.png`);

function LinkPro({ cancelClick, modalHasEntered }) {
  const redirect = () => { window.open(`https://www.beatsource.com/subscriptions`, `_blank`) }
  return (
    <div className={`flexColumn linkPro`}>
      <div className={`flexColumn container`}>
        <IconClose size={16} color={`#FAFAFA`} onClick={cancelClick} className={`lm-close-icon`} />
        <img className={`cover`} src={LMC} alt={`LMC`} />
        <div className={`logo center`}>
          <LogoLink />
        </div>
        <div className={`title type-title center`}>Upgrade for DJ Edits.</div>
        <div className={`description type-regular center`}>DJ edits are only available to Pro+ users.  Upgrade now to access thousands of DJ edits including Intros, Clean Edits, Instrumentals, Acapellas, and more.</div>
        <div className={`flexRow center`}>
          <Button label={`Upgrade to Pro+`} className={`medium primary type-small lm-button`} onClick={redirect} />
        </div>
      </div>
    </div>
  )
}

LinkPro.propTypes = {
  cancelClick: PropTypes.func,
  modalHasEntered: PropTypes.bool
}

export default LinkPro;
